import IzinForm from "./components/IzinForm";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { useRef, useState } from "react";

export default function IzinFormPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const jenis = location.state?.jenis;
  const [keterangan, setKeterangan] = useState("");
  const formRef = useRef();

  const handleAjukan = async () => {
    if (!formRef.current) return;

    const sukses = await formRef.current.submitIzin();

    if (sukses) {
      navigate(-1);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      
      {/* HEADER */}
      <div style={{ height: 70, display: "flex", alignItems: "center", padding: "0 16px" }}>
        <motion.button onClick={() => navigate(-1)} initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} whileTap={{ scale: 0.9 }} style={{ width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", background: "#fff", borderRadius: "50%", boxShadow: "0 2px 6px rgba(0,0,0,0.15)", cursor: "pointer", border: "none", }} aria-label="Kembali" > <ArrowLeft size={22} color="#333" /> </motion.button>

        <h3 style={{ marginLeft: 12 }}>
          Form Pengajuan {jenis?.nama || ""}
        </h3>
      </div>

      {/* CONTENT */}
      <div style={{ padding: "0 16px 10px 16px" }}>
        <IzinForm
          ref={formRef}
          defaultJenis={jenis}
          ijinOptions={[]}
          keterangan={keterangan}
          setKeterangan={setKeterangan}
          isModalOpen={false}
        />
      </div>

      {/* FIXED FOOTER */} 
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "#fff", padding: "16px", boxShadow: "0 -2px 6px rgba(0,0,0,0.1)", display: "flex", gap: "12px", justifyContent: "center", }} >
          <button onClick={() => navigate(-1)} style={{ flex: 1, padding: "12px", borderRadius: 12, border: "1.5px solid #ddd", background: "#f8fafc", fontSize: 16, fontWeight: 500, cursor: "pointer", }} > Batal 
          </button> 
          <button onClick={handleAjukan} style={{ flex: 1, padding: "12px", borderRadius: 12, border: "none", background: "#007bff", color: "#fff", fontSize: 16, fontWeight: 500, cursor: "pointer", }} > Ajukan 
          </button> 
      </div>
    </div>
  );
}
